export function hideKrpano() {
    let z = document.getElementById("krpano-kr");
    if (z) z.style.display = "none";
    z = document.getElementById("krpano-kr-mobile");
    if (z) z.style.display = "none";
}